export var ILedgerSnapShotExtentionTYPES;
(function (ILedgerSnapShotExtentionTYPES) {
    ILedgerSnapShotExtentionTYPES["PAYIN"] = "PAYIN";
    ILedgerSnapShotExtentionTYPES["PAYOUT"] = "PAYOUT";
    ILedgerSnapShotExtentionTYPES["CASH"] = "NSE_Credit,NSE_Debit,BSE_Credit,BSE_Debit";
    ILedgerSnapShotExtentionTYPES["DERIVATIVES"] = "NSEF_Credit,NSEF_Debit,NSEC_CREDIT,NSEC_DEBIT,BSEF_CREDIT,BSEF_DEBIT,MCX_CREDIT,MCX_DEBIT";
    ILedgerSnapShotExtentionTYPES["MFSS"] = "NSEM_Credit,NSEM_Debit";
})(ILedgerSnapShotExtentionTYPES || (ILedgerSnapShotExtentionTYPES = {}));
